<!-- 商户管理/商户列表 -->
<template>
  <el-table :data="tableData" style="width: 100%;border: 1px solid #f1f1f1">
    <el-table-column sortable label="编号" align="center" prop="id" width="80">
    </el-table-column>
    <el-table-column label="商户名称" align="center">
      <template slot-scope="scope">
        <div class="table_scope_line">{{ scope.row.merch_name }}</div>
        <div class="table_scope_line">认证时间：{{ scope.row.rzTime }}</div>
        <div class="table_scope_line">到期时间：{{ scope.row.dqTime }}</div>
      </template>
    </el-table-column>
    <el-table-column label="状态" align="center">
      <template slot-scope="scope">
        <div class="table_scope_line">
          {{ scope.row.status == 1 ? "正常" : "禁用" }}
        </div>
        <div class="table_scope_line">信用分：{{ scope.row.xyScore }}</div>
        <div class="table_scope_line">信用级别：{{ scope.row.xyGrade }}</div>
        <div class="table_scope_line">店铺保证金：{{ scope.row.bzMoney }}</div>
      </template>
    </el-table-column>
    <el-table-column label="商户类型" align="center">
      <template slot-scope="scope">
        <div class="table_scope_line">类型：{{ scope.row.run_type }}</div>
        <div class="table_scope_line">结算费率：{{ scope.row.rate }}</div>
        <div class="table_scope_line">加入方式：{{ scope.row.joinType }}</div>
        <div class="table_scope_line">店铺级别：{{ scope.row.shopGrade }}</div>
      </template>
    </el-table-column>
    <el-table-column label="账户余额" align="center">
      <template slot-scope="scope">
        <div class="table_scope_line">总余额：{{ scope.row.zye }}</div>
        <div class="table_scope_line">可用余额：{{ scope.row.kyye }}</div>
        <div class="table_scope_line">冻结余额：{{ scope.row.djye }}</div>
      </template>
    </el-table-column>
    <el-table-column label="联系人" align="center">
      <template slot-scope="scope">
        <div class="table_scope_line">联系人：{{ scope.row.contact_name }}</div>
        <div class="table_scope_line">电话：{{ scope.row.contact_mobile }}</div>
        <div class="table_scope_line">上级：{{ scope.row.higher }}</div>
      </template>
    </el-table-column>
    <el-table-column label="统计" align="center">
      <template slot-scope="scope">
        <div class="table_scope_line">成交量：{{ scope.row.cjl }}</div>
        <div class="table_scope_line">成交额：{{ scope.row.cje }}</div>
        <div class="table_scope_line">店铺评分：{{ scope.row.dppf }}</div>
        <div class="table_scope_line">差评数：{{ scope.row.cps }}</div>
        <div class="table_scope_line">差评率：{{ scope.row.cpl }}</div>
      </template>
    </el-table-column>
    <el-table-column label="操作" align="center">
      <template slot-scope="scope">
        <div class="table_button_line">
          <el-button type="text" @click="editShopDetail(scope.row.id)"
            >编辑</el-button
          >
          <el-button type="text">删除</el-button>
          <el-button type="text">信用删除</el-button>
        </div>
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
export default {
  props: {
    tableData: {
      type: Array,
      default: function() {
        return [];
      }
    }
  }
};
</script>
